import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=4e2afbbe&scoped=true&"
import script from "./Partner.vue?vue&type=script&lang=ts&"
export * from "./Partner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2afbbe",
  null
  
)

export default component.exports